import React from "react";

export default function StepHeader({
    step = 1,
    totalSteps = 5,
    title = '',
    subtitle = '',
    isAdvisor
}) {
    const progressPercent = (step / totalSteps) * 100;

    return (
        <div className="step-wrapper mobile-only">
            {/* Progress Bar */}
            <div className="progress-row">
                <div className="progress-bar">
                    <div
                        className="progress-fill"
                        style={{
                            width: `${progressPercent}%`,
                        }}
                    />
                </div>
                <div className="progress-count">
                    {step}/{totalSteps}
                </div>
            </div>

            {/* Step Card */}
            <div className="step-card">
                <div className="step-title">
                    <p className="step-number">Step {step}:</p> {title}
                </div>
                <div className="step-subtitle">{subtitle}</div>
            </div>
        </div>
    );
}
